export const selectFavoritesState = (state) => state.favorites;

export const selectFavoritesItems = (state) => state.favorites.items;

export const selectFavoritesCount = (state) => state.favorites.items.length;

export const selectIsItemFavorite = (state, productId) => {
    return state.favorites.items.some(item => item.id === productId);
};
